// LocationDropdown.js
import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const districts = {
  "Mueang Phuket": [
    "Talat Yai", "Talat Nuea", "Ratsada", "Wichit", "Chalong", "Rawai", "Karon","Koh Kaew"
  ],
  "Kathu": [
    "Kathu", "Patong", "Kamala"
  ],
  "Thalang": [
    "Thep Krasatti", "Srisunthorn", "Cherng Talay", "Paklok", "Mai Khao", "Saku"
  ]
};

const allLocations = Object.values(districts).flat();

const popularLocations = [
  "Patong","Kathu","Karon","Cherng Talay","Rawai","Srisunthorn","Paklok","Koh Kaew"
];

function LocationDropdown({ selectedLocations, setSelectedLocations }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  const { t } = useTranslation();

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleLocation = (loc) => {
    if (selectedLocations.includes(loc)) {
      setSelectedLocations(selectedLocations.filter(l => l !== loc));
    } else {
      setSelectedLocations([...selectedLocations, loc]);
    }
  };

  const selectAll = () => {
    if (selectedLocations.length === allLocations.length) {
      setSelectedLocations([]);
    } else {
      setSelectedLocations([...allLocations]);
    }
  };

  const displayText = selectedLocations.length === 0
    ? t('Select Locations')
    : selectedLocations.length === 1
    ? selectedLocations[0]
    : `${selectedLocations.length} Locations Selected`;

  return (
    <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
      <div 
        onClick={() => setOpen(!open)}
        style={{
          border: '1px solid #ccc',
          padding: '10px 16px',
          borderRadius: 30,
          cursor: 'pointer',
          background: '#fff',
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          userSelect: 'none',
          color: 'black'
        }}
      >
        {displayText}             
      </div>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1002,
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: 12,
            padding: '15px 20px',
            width: '360px',
            maxHeight: '320px',
            overflowY: 'auto',
            boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
            color: 'black',
            textAlign: 'left' // ✅ ชิดซ้ายทั้งหมด
          }}
        >
          {/* Popular */}
          <div style={{ marginBottom: '12px' }}>
            <strong style={{ display: 'block', marginBottom: '5px', fontSize: '18px' }}>{t('Popular')}</strong>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
              <input
                type="checkbox"
                checked={selectedLocations.length === allLocations.length}
                onChange={selectAll}
              />
              <span>{t('Select All')}</span>
            </label>
            {popularLocations.map((loc) => (
              <label key={loc} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '10px', marginBottom: '4px' }}>
                <input
                  type="checkbox"
                  checked={selectedLocations.includes(loc)}
                  onChange={() => toggleLocation(loc)}
                />
                <span>{t(loc)}</span>
              </label>
            ))}
          </div>

          <hr style={{ margin: '10px 0', borderColor: '#eee' }} />

          {/* Districts */}
          {Object.entries(districts).map(([district, subdistricts]) => (
            <div key={district} style={{ marginBottom: '10px' }}>
              <strong style={{ display: 'block', marginBottom: '5px', fontSize: '18px' }}>
                {t(district)}
              </strong>
              {subdistricts.map((loc) => (
                <label key={loc} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '14px', marginBottom: '4px' }}>
                  <input
                    type="checkbox"
                    checked={selectedLocations.includes(loc)}
                    onChange={() => toggleLocation(loc)}
                  />
                  <span>{t(loc)}</span>
                </label>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LocationDropdown;
